<div style="display: flex; justify-content: space-between;">
<h2 mat-dialog-title mat-dialog-draggable-title style="font-size: 18px; font-weight: 700;">
  {{ "sign_processing_dialog.title_2" | translate }}
</h2>
<!-- <h2 mat-dialog-title mat-dialog-draggable-title style="right: 0; margin-bottom: 0px !important; display: flow-root;">
        <button *ngIf="isCloseButton == true" type="button" class="close" aria-label="Close" (click)="onNoClick()">
          <span aria-hidden="true">&times;</span>
        </button>
</h2> -->
</div>

<mat-divider style="padding-bottom: 12px;"
  *ngIf="
    dataDialog.errorStatus || !dataDialog.signError || !dataDialog.isCancel
  "
></mat-divider>
<div class="hint" style="background: #FEF5E7; border: 1px solid #F59E0B; color: #F59E0B; padding: 12px 16px; gap: 12px; margin-bottom: 16px; border-radius: 12px; font-size: 14px; font-weight: 600;">
  <em class="material-icons">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 17.6586V20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20V17.6586M12 2V3M3 12H2M5.5 5.5L4.8999 4.8999M18.5 5.5L19.1002 4.8999M22 12H21M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z" stroke="#F59E0B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg> 
  </em>
  {{ "sign_processing_dialog.title_hint" | translate }}
</div>
<div style="padding: 0px 16px;">
<mat-progress-bar
  mode="indeterminate"
  *ngIf="
    statusSign == 1; 
  "
></mat-progress-bar>
<mat-dialog-content>
  <div class="row px-1 py-1">
    <div class="col-12 pt-2">
      <p class="error-text mb-0" *ngIf="messages">
        {{ "popup_notify.fail_1" | translate }}
      </p>
      <div class="error-text mb-0" *ngIf="messages">
        {{messages}}
      </div>
      <p
        class="error-text mb-0"
        *ngIf="messages"
      >
        {{ "sign_processing_dialog.note_close_dialog" | translate }}
      </p>
      <p class="text-right">
        {{ "sign_processing_dialog.sign" | translate }}
        {{ countSign }}/1 file
      </p>
    </div>
    <div class="col-12">
     <mat-table [dataSource]="fixedData" matSort>
  <ng-container matColumnDef="stt">
    <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
      {{ "headertable.index" | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="text-center">
      1
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
      {{ "headertable.name_file_page_sign" | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element">
      {{ "notifyTindy.bienBanUyQuyen" | translate }}
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="status">
    <mat-header-cell *matHeaderCellDef class="mat-cell-non-boder-right-bottom">
      {{ "headertable.status" | translate }}
    </mat-header-cell>
    <mat-cell *matCellDef="let element" class="text-center">
      <mat-icon style="color: #07736c" *ngIf="statusSign == 3">done</mat-icon>
      <mat-icon style="color: red;" *ngIf="statusSign == 2">close</mat-icon>
      <mat-icon style="color: orange;" *ngIf="statusSign == 1">sync</mat-icon>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>
    </div>
  </div>
</mat-dialog-content>
</div>

<mat-dialog-actions align="center" class="mt-2">
  <!-- *ngIf="!dataDialog.errorStatus && !dataDialog.signError" -->
  <button
    (click)="onNoClick()"
    mat-stroked-button
    color="primary"
    class="mr-3"
    type="button"
    *ngIf="isCloseButton == true"
    mat-dialog-close
  >
    <mat-icon class="mr-0">cancel</mat-icon>{{ "button.close" | translate }}
  </button>
</mat-dialog-actions>
